export default __webpack_public_path__ + "static/media/24dokan-logo.7e696c2c.png";